/**
 * Formules partagées par les calculateurs gratuits (pente, squares, bardeaux).
 *
 * Elles vivent ici plutôt que dans chaque page pour qu'une correction se fasse
 * à un seul endroit : trois pages qui donneraient trois réponses différentes au
 * même toit détruiraient la crédibilité qu'on cherche justement à bâtir.
 *
 * Rien ici ne touche au moteur d'estimation (lib/roof.js) : ces pages sont
 * publiques et ne dépendent d'aucun compte.
 */

/** Surface réelle d'un pan = empreinte x racine(1 + (rise/run)²). */
export const multiplicateur = (rise, run) => Math.sqrt(1 + (rise / run) ** 2);

export const degres = (rise, run) => (Math.atan(rise / run) * 180) / Math.PI;

/** Affichage court : deux décimales, sans « ,00 » inutile. */
export const arrondi = (n, d = 2) =>
  Number.isFinite(n) ? n.toFixed(d).replace(/\.00$/, "") : "—";

export const millier = (n) =>
  Number.isFinite(n) ? Math.round(n).toLocaleString("en-US") : "—";

/** Un square de toiture = 100 pi² de surface INCLINÉE, jamais d'empreinte. */
export const PI2_PAR_SQUARE = 100;

/**
 * Trois paquets couvrent un square pour un bardeau architectural ou à trois
 * pattes standard. Les bardeaux lourds (designer, certains profils) montent à
 * quatre ou cinq paquets : c'est un choix de l'utilisateur, pas une constante.
 */
export const PAQUETS_PAR_SQUARE = 3;

/** Table de référence 0/12 à 18/12, recalculée et non recopiée. */
export const TABLE_PENTES = Array.from({ length: 19 }, (_, rise) => ({
  rise,
  ratio: `${rise}/12`,
  angle: degres(rise, 12),
  pente: (rise / 12) * 100,
  mult: multiplicateur(rise, 12),
  nom:
    rise === 0
      ? "Flat"
      : rise <= 3
      ? "Low slope"
      : rise <= 6
      ? "Conventional"
      : rise <= 9
      ? "Steep"
      : "Very steep — steep-slope charges apply",
}));
